import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Bell: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 20 21.996"
    >
      <defs></defs>
      <g transform="translate(-2 -1)">
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          d="M18,8A6,6,0,1,0,6,8c0,7-3,9-3,9H21s-3-2-3-9"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          d="M13.73,21a2,2,0,0,1-3.46,0"
        />
      </g>
    </svg>
  );
};

export default Bell;
